import React from 'react';
import {Link} from 'react-router-dom';

import Card from 'antd/lib/card';
import Avatar from 'antd/lib/avatar';

import dummyAvatar from '@common/react/images/avatar.jpg';

import {Doctor} from '@app/objects/Doctor';

interface Props {
	doctor: Doctor;
}

const DoctorCardHome: React.FC<Props> = ({doctor}) => {
	const {
		nameEn,
		avatar,
		portalPathEn,
		averageReviewRate,
		portalShortText,
		totalReviewCount
	} = doctor;

	const ref = React.useRef<HTMLDivElement | null>(null);
	const [visible, setVisible] = React.useState(false);

	React.useEffect(() => {
		if (ref.current) {
			const intersectionObserver = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					setVisible(true);
				}
			}, {
				rootMargin: '15px',
				threshold: 0.01
			});

			intersectionObserver.observe(ref.current);
			return () => intersectionObserver.disconnect();
		}
	}, [ref.current]);

	const title = React.useMemo(() => <>
		<div className="row">
			<div className="col-sm-12">
				<div className="card-title">
					<h3 className="mt10 mb10">{portalPathEn ? <Link to={`/doctor/${portalPathEn}`}>{nameEn}</Link> : nameEn}</h3>
				</div>
				<div>
					<div className="doctor-rate mb10">
						<strong className="mr10">
							{Array.from({ length: Math.round(averageReviewRate || 0) })
								.map((_, i) => <i className="fa fa-star" key={i} aria-hidden="true" />)}
						</strong>
						({totalReviewCount})
					</div>
					{portalShortText ?
						<div className="ant-card-meta-description mb10">{portalShortText}</div> : null
					}
				</div>
			</div>
		</div>
	</>, [nameEn, portalShortText, portalPathEn, averageReviewRate]);

	return (
		<div className="doctor-card" ref={ref}>
			<Card style={{ width: '100%' }}>
				<Card.Meta
					avatar={<Link to={`/doctor/${portalPathEn}`}>
						<Avatar src={visible ? (avatar ? `/remote/${avatar}` : dummyAvatar) : ''} />
					</Link>}
					title={title}
				/>
			</Card>
		</div>
	);
};

export default DoctorCardHome;